import CookieEnum from "constants/CookieEnum";
import RouteEnum from "constants/RouteEnum";
import IStore from "models/IStore";
import IUserCookieModel from "models/common-models/IUserCookieModel";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCookie } from "utilities/CookieUtility";

interface IProps {
  readonly children: React.ReactElement;
}

const AuthRoute: React.FC<IProps> = ({ children }) => {
  const navigate = useNavigate();
  const token: string | null = useSelector((state: IStore) => state.auth.token);
  const user: IUserCookieModel | null = useSelector((state: IStore) => state.auth.user);
  const redirectPath: string | undefined = useSelector((state: IStore) => state.auth.redirectPath);

  useEffect(() => {
    if (token && user) {
      setTimeout(() => {
        if (redirectPath) {
          navigate(redirectPath, { replace: true });
        } else {
          navigate(RouteEnum.Profile, { replace: true });
        }
      }, 1000);
    } else {
      const cookieToken = getCookie(CookieEnum.Token);
      if (cookieToken) {
        navigate(RouteEnum.Profile, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user, redirectPath]);

  return children;
};

export default AuthRoute;
